import React, { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Ensures every route change starts at the top of the page.
 *
 * Uses `useLayoutEffect` so the scroll happens BEFORE the browser paints the
 * new page — this eliminates the brief flash where policy pages would appear
 * pre-scrolled to the bottom because of the outgoing footer position.
 *
 * We only reset scroll when the pathname changes. Query-string-only changes
 * (like the sticky category pills toggling `?category=...`) do NOT trigger a
 * scroll reset — that would cause the annoying "jump up then scroll down"
 * flash the user reported. Any page that wants to scroll on a query change
 * handles it locally (see Home.jsx).
 */
export default function ScrollToTop() {
    const { pathname } = useLocation();
    useLayoutEffect(() => {
        try { window.scrollTo({ top: 0, left: 0, behavior: 'instant' }); }
        catch { window.scrollTo(0, 0); }
    }, [pathname]);
    return null;
}
